import React from 'react';
import { Modal, Button } from 'antd';
import i18n from 'i18next';
import { GlobalModalProps, closeModal } from '../PlaceOrder';

import Icon from '../../../assets/images/png/dashed-list.png';

export const OrderSent: React.FC = () => {
  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-icon margin-top">
        <img src={Icon} alt="modal-content-icon" />
      </div>
      <div className="modal-content-description">
        <span>{i18n.t('ORDER_SENT')}</span>
        <div className="modal-content-extra-text">
          {i18n.t('PROSSECCING_TO_COOK')}
        </div>
      </div>
      <div className="button-container">
        <Button
          block
          type="primary"
          shape="round"
          onClick={closeModal}
          className="continue-button continue-button-primary"
        >
          <span className="continue-button-text">{i18n.t('Continue')}</span>
        </Button>
      </div>
    </div>
  );
};

export const orderSentModalHandler = () => {
  Modal.info({
    ...GlobalModalProps,
    centered: true,
    content: <OrderSent />,
  });
};
